import { Component, HostBinding, Input } from '@angular/core';
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.css'],
  standalone: false
})
export class NavContentComponent {
  @Input()
  @HostBinding('class.confetti-sm')
  showConfettiInSmallScreen = true;
  @Input()
  @HostBinding('class.confetti-lg')
  showConfettiInLargeScreen = true;
  @Input()
  @HostBinding('style.background-position-y')
  backgroundYPositionSm = '1rem';

  @Input()
  @HostBinding('style.--navigation-sheet-background-image')
  backgroundImage?: string;

  @HostBinding('class.hide-footer')
  whiteLabel: boolean;

  constructor(private registrationService: RegistrationService) {
    this.whiteLabel = this.registrationService.whiteLabel;
  }

}
